import { setLocale } from '@marketplace/helpers/datetime.js'

/**
 * Dayjs for all the date/time manipulation and parsing.
 *
 * @param {object} context
 * @param {object} context.app
 */
export default function ({ app }) {
    setLocale(app?.i18n?.locale)
}
